import { useObservableInternal } from './internal/use-observable-internal';
import { useEffect } from 'react';
export function useObservable(init, inputs) {
    return useObservableInternal(useEffect, init, inputs);
}
//# sourceMappingURL=use-observable.js.map